import { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { StringInputHook } from 'src/components/common/form';
import { IAppActionInput } from 'src/lib/schemas';

interface StringInputWidgetProps {
	input: IAppActionInput;
	validationRules: Record<string, any>;
	propertyPrefix?: string;
}

const StringInputWidget: FC<StringInputWidgetProps> = ({
	input,
	validationRules,
	propertyPrefix = '',
}) => {
	const { control } = useFormContext();

	let placeholder = `Enter ${input.name.toLowerCase()}`;
	if (input.placeholder) {
		placeholder = input.placeholder;
	}

	return (
		<Controller
			name={input.property}
			control={control}
			rules={validationRules}
			render={() => (
				<StringInputHook
					name={propertyPrefix + input.property}
					requirementsLabel={input.explanation}
					label={input.name}
					placeholder={placeholder}
					required={validationRules.required}
					error={validationRules?.message}
				/>
			)}
		/>
	);
};

export default StringInputWidget;
